import { headerStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationHeader";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS } from "@tSurya/theme/design";
import { css } from "styled-components";

headerStyles.printButton = {
    variant: "secondary",
    css: css`
        border: 2px solid ${getColor("primary")};
    `,
};
